import { extend, override } from 'flarum/extend';
import app from 'flarum/app';
import HeaderSecondary from 'flarum/components/HeaderSecondary';
import SettingsPage from 'flarum/components/SettingsPage';
import LogInModal from 'flarum/components/LogInModal';

import RedirectToHomepage from './components/RedirectToHomepage'
import Page from 'flarum/components/Page'

app.initializers.add('fstln/flarum-ext-sso', () => {
  // Remove login button if checkbox is selected
  extend(HeaderSecondary.prototype, 'items', (items) => {
    const user = app.session.user
    if (user) {
      items.add('points',
        <div class="NotificationsDropdown itemCount0">
          <button class="Dropdown-toggle Button Button--flat" title="Points" style="position: relative;"> 
            <span class="icon fas Button-icon" style="vertical-align: middle;">
              <svg xmlns="http://www.w3.org/2000/svg" style="width: 20px; height: 20px; display: flex; margin: 0 auto;" viewBox="0 0 31 31" fill="none">
                <path d="M18.0074 0.00439453C24.6348 0.00439453 30.0074 5.37698 30.0074 12.0044C30.0074 16.8713 27.11 21.0615 22.946 22.9443C21.0633 27.1078 16.8735 30.0043 12.0074 30.0043C5.3799 30.0043 0.00732422 24.6318 0.00732422 18.0044C0.00732422 13.1382 2.90385 8.94849 7.06683 7.06536C8.95022 2.90175 13.1405 0.00439453 18.0074 0.00439453ZM13.5074 10.5044H10.5073V12.0044C8.43626 12.0044 6.75732 13.6833 6.75732 15.7544C6.75732 17.7426 8.30464 19.3695 10.2608 19.4964L10.5073 19.5044H13.5074L13.6422 19.5165C13.992 19.58 14.2574 19.8862 14.2574 20.2544C14.2574 20.6226 13.992 20.9287 13.6422 20.9923L13.5074 21.0043H7.50732V24.0043H10.5073V25.5043H13.5074V24.0043C15.5784 24.0043 17.2574 22.3254 17.2574 20.2544C17.2574 18.2661 15.71 16.6393 13.754 16.5123L13.5074 16.5044H10.5073L10.3725 16.4923C10.0226 16.4287 9.75732 16.1226 9.75732 15.7544C9.75732 15.3863 10.0226 15.0799 10.3725 15.0165L10.5073 15.0044H16.5074V12.0044H13.5074V10.5044ZM18.0074 3.0044C15.3321 3.0044 12.9294 4.17163 11.281 6.02463C11.522 6.01164 11.7638 6.00439 12.0074 6.00439C18.6348 6.00439 24.0074 11.377 24.0074 18.0044C24.0074 18.2484 24 18.4908 23.9858 18.7311C25.8398 17.083 27.0074 14.68 27.0074 12.0044C27.0074 7.03383 22.9779 3.0044 18.0074 3.0044Z" fill="black"/>
              </svg>
            </span>

            <span class="Button-label">Heyup Points</span>
            <a href="https://heyupnow.com/account#reward-points" target="_blank" class="stretched-link"></a>
          </button>
        </div>
        , 
        12
      );
    }

    if (checkSettings('login_url')) {
      if (app.forum.attribute('fstln-sso.remove_login_btn') === '1') {
        items.remove('logIn');
      } else {
        // Remove login button
        if (!items.has('logIn')) {
          return;
        }
        let loginUrl = app.forum.attribute('fstln-sso.login_url');
        const returnTo = encodeURIComponent(self.location.href);
        if (loginUrl.indexOf('?') !== -1) {
          loginUrl = loginUrl + '&return_to=' + returnTo;
        } else {
          loginUrl = loginUrl + '?return_to=' + returnTo;
        }

        items.replace('logIn',
          <a href={loginUrl} className="Button Button--link">
            {app.translator.trans('core.forum.header.log_in_link')}
          </a>);

        override(LogInModal.prototype, 'oninit', () => {
          window.location.href = loginUrl;
          throw new Error('Stop execution');
        });
      }
    }

    if (checkSettings('signup_url')) {
      if (app.forum.attribute('fstln-sso.remove_signup_btn') === '1') {
        items.remove('signUp');
      } else {
        // Replace signup button
        if (!items.has('signUp')) {
          return;
        }

        let signupUrl = app.forum.attribute('fstln-sso.signup_url');
        const returnTo = encodeURIComponent(self.location.href);
        if (signupUrl.indexOf('?') !== -1) {
          signupUrl = signupUrl + '&return_to=' + returnTo;
        } else {
          signupUrl = signupUrl + '?return_to=' + returnTo;
        }

        items.replace('signUp',
          <a href={signupUrl} className="Button Button--link">
            {app.translator.trans('core.forum.header.sign_up_link')}
          </a>);
      }
    }
  });

  extend(SettingsPage.prototype, 'accountItems', (items) => {
    if (!checkSettings('login_url')) {
      return;
    }

    // Remove change email and password buttons
    items.remove('changeEmail');
    items.remove('changePassword');
    
    let change_password_url = app.forum.attribute('fstln-sso.change_password_url');
    const returnTo = encodeURIComponent(self.location.href);

    let signupUrl = app.forum.attribute('fstln-sso.signup_url');
    
    if (signupUrl.indexOf('?') !== -1) {
      change_password_url = change_password_url + '&return_to=' + returnTo;
    } else {
      change_password_url = change_password_url + '?return_to=' + returnTo;
    }
    items.add(
      'changePassword',
      <a class="Button" href={change_password_url}
        target='_blank'>
        {app.translator.trans('fstln-sso.forum.change_password_url')}
      </a>,
    );

    var change_username_url = app.forum.attribute('fstln-sso.change_username_url');
    if (signupUrl.indexOf('?') !== -1) {
      change_username_url = change_username_url + '&return_to=' + returnTo;
    } else {
      change_username_url = change_username_url + '?return_to=' + returnTo;
    }
    items.add(
      'changeUsername',
      <a class="Button" href={change_username_url}
        target='_blank'>
        {app.translator.trans('fstln-sso.forum.change_username_url')}
      </a>,
    );

    if (!checkSettings('manage_account_url')) {
      return;
    }

    var manageAccountUrl = app.forum.attribute('fstln-sso.manage_account_url');
    // items.add(
    //   'manageAccount',
    //   <a class="Button" href={manageAccountUrl}
    //     target={app.forum.attribute('fstln-sso.manage_account_btn_open_in_new_tab') === '1' ? '_blank' : ''}>
    //     {app.translator.trans('fstln-sso.forum.manage_account_btn')}
    //   </a>,
    // );
  });

  extend(SettingsPage.prototype, 'settingsItems', (items) => {
    if (checkSettings('manage_account_url')) {
      return;
    }

    // Remove account section
    if (items.has('account') && items.get('account').children.length === 0) {
      items.remove('account');
    }
  });

  extend(Page.prototype, 'oninit', function (vnode) {
    // redirect to homepage if unlogin
    // RedirectToHomepage()
  })

  /**
   * Checks whether login URL is set
   *
   * @returns Boolean
   */
  function checkSettings(slug) {
    return Boolean(app.forum.attribute(`fstln-sso.${slug}`));
  }
});
